// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-position-modal .bx--modal-header__heading{font-size:20px}.delete-position-modal .bx--modal-content{font-size:14px;padding:16px}.delete-position-modal .bx--btn{font-size:14px;min-height:48px}.delete-position-modal .bx--modal-footer{height:48px}.delete-position-modal .bx--modal-close{width:48px;height:48px}.delete-position-modal .bx--modal-close__icon{height:20px;width:20px}", ""]);
// Exports
module.exports = exports;
